module.exports = __webpack_public_path__ + "fonts/fa-solid-900.2e302fa4.eot";